var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[(!_vm.loaded)?_c('DotLoader'):_vm._e(),_vm._v(" "),_c('iframe',{staticClass:"content",attrs:{"src":_vm.url,"width":"100%","height":"100%"},on:{"load":function($event){_vm.loaded = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }